var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceByTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#346dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.5,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "20 15 16 12 16 14 4 14 4 12 0 15 4 18 4 16 16 16 16 18 20 15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,0a5,5,0,1,0,5,5A5,5,0,0,0,10,0Zm0,8.62A3.59,3.59,0,0,1,6.44,5a3.56,3.56,0,1,1,7.12,0A3.59,3.59,0,0,1,10,8.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.69,4.54H10.48V3.16a.61.61,0,0,0-1.22,0v2a.6.6,0,0,0,.61.59h1.82a.6.6,0,0,0,.61-.59A.59.59,0,0,0,11.69,4.54Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceByTime);
export default __webpack_public_path__ + "static/media/SpaceByTime.2f24f111a76324afbbbb44fae3217642.svg";
export { ForwardRef as ReactComponent };